import React from "react";

const handleContactlessPayments = (props) => {
  const options = [
    {
      text: 'How do Interac Debit Chip and PIN and contactless payment transactions work?',
      handler: props.actionProvider.handleContactlessPayments1,
      id: 1,
    },
    {
      text: 'How secure are Interac Debit and contactless payments?',
      handler: props.actionProvider.handleContactlessPayments2,
      id: 2
    },
    {
      text: 'What safeguards are in place with Interac Debit Chip and PIN and contactless payments to protect me against fraudulent transactions?',
      handler: props.actionProvider.handleContactlessPayments3,
      id: 3
    },
    {
      text: 'What does "provided you took reasonable measures to protect your card and PIN" mean?',
      handler: props.actionProvider.handleContactlessPayments4,
      id: 4
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleContactlessPayments;